module.exports = __webpack_public_path__ + "img/receipt-header_short.438a21eb.png";